import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
    selector: 'app-session-days',
    templateUrl: './session-days.component.html',
    styleUrls: ['./session-days.component.scss'],
    standalone: false
})
export class SessionDaysComponent implements OnInit {
  
    @Input() public form : UntypedFormGroup;

    @Input() public readonly : boolean;

    constructor() { 

    }

    ngOnInit(): void {
     
    }


}
